import cookies from "react-cookies";

class Auth  {
	constructor(parent) {
		this.parent = parent;
		this.sid = cookies.load('PHPSESSID');
		this.user = null;
	}
	
	getUserProp(prop) {
		if (this.user == null)
			return null;
		return this.user[prop];
	}
	
	softUserProp(prop) {
		let p = this.getUserProp(prop);
		return (p == null) ? '' : p;
	}

	hasPermission(p) {
		console.log("Checking if user has permission", p, this.user.permissions);
		if (this.user == null) return false;
		return (this.user.permissions.hasOwnProperty('isAdmin') && this.user.permissions['isAdmin'] == true)
			|| (this.user.permissions.hasOwnProperty(p) && this.user.permissions[p] == true);
	}
	
	//getName() { return this.getUserProp('first_name'); }
	
	deleteCookie() {
		cookies.remove('PHPSESSID',{ path: '/' });
	}
	
	userID() { return this.getUserProp('user_id'); }
	
	isCurrentUser(uid) {
		return this.user.user_id != null && this.userID() === uid;
	}
	
	async isLoggedIn() {
		if (this.sid == null) {
			return false;
		}
		
		if (this.user == null) {
			const result = await this.parent.get('auth');
			this.user = result;
			this.parent.call('Auth.userRetrieved', [result]);
			return true;
		}
		return true;
	}
	
	async login(username, password) {
		const result = await this.parent.post('auth', {'u': username, 'p': password})
		this.sid = result.sid;
		this.user = result;
		cookies.save('PHPSESSID', this.sid, { path: '/' })
		this.parent.call('Auth.loggedIn', [result]);
		return result;
	}
	
	logout() {
		console.log("Logging out?");
		this.parent.del('auth').then(
			(result) => {
				this.loggedout();
				console.log('logged out', [result]);
			}
		).catch(this.parent.catcher);
		this.sid = null;
	}
	
	loggedout() {
		this.deleteCookie();
		this.user = null;
		this.parent.call('Auth.loggedOut');
	}
	
	/*
	saveProfile(location, reference_string) {
		this.parent.put('users', {'location': location, 'reference_string': reference_string})
			.then(
				(result) => {
					this.parent.call('profileUpdated', [result]);
					this.user.location = location;
					this.user.reference_string = reference_string;
					this.parent.success("Profile updated!");
			}
		).catch(this.parent.catcher);
	}
	
	
	updatePassword(password) {
		this.parent.put('users', {'password': password})
			.then(
				(result) => {
					this.parent.call('passwordUpdated', [result]);
					this.parent.success("Password updated!");
			}
		).catch(this.parent.catcher);
	}
	
	register(email, first_name, last_name, location, reference_string) {
		this.parent.post('users', {'u': email, 'first_name': first_name, 'last_name': last_name, 'location': location, 'reference_string': reference_string})
			.then(
				(result) => {
					this.parent.call('registered', [result]);
					this.parent.success("User registered - check your email for details.");
			}
		).catch((e) => {
				this.parent.call('registrationError', [e]);
				this.parent.catcher(e);
			}
		);
	}
	
	
	resetPassword(key, password) {
		this.parent.post('auth/reset', {'key': key, 'p': password})
			.then(
				(result) => {
					this.parent.call('passwordUpdated', [result]);
					this.parent.success("Your password has been reset!");
			}
		).catch(this.parent.catcher);
	}
	
	forgottenPassword(email) {
		this.parent.post('auth/forgot', {'u': email})
			.then(
				(result) => {
					this.parent.call('forgottenPassword', [result]);
					this.parent.success("A reset link has been emailed to you.");
			}
		).catch(this.parent.catcher);
	}*/

}


export default Auth;